export default __webpack_public_path__ + "fonts/logo-white_2f38e04321dd9dca9bb7714b9d33e93f.svg";